import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'dialog-judgspreadsheet-component',
    styleUrls: ['judgespreadsheet.dialogcomponent.scss'],
    templateUrl: 'judgespreadsheet.dialogcomponent.html',
})

export class JudgeSpreadsheetDialogComponent {
    file: File = null;
    multipleFiles: boolean = false;

    constructor(
        private dialogRef: MatDialogRef<JudgeSpreadsheetDialogComponent>
    ) { }

    onFileSelected(files: File[]) {
        this.multipleFiles = files.length > 1;
        this.file = files[0];
    }

    Upload() {
        if (this.file != null) {
            this.dialogRef.close(this.file);
        }
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

}